import React from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

const PayPalButtonComponent = ({amount, currency, onSuccess, fundingSource}) => {
  // Define the amount and currency
//   const amount = "10.00"; // Amount to be charged
//   const currency = "USD"; // Currency code

    // const script = document.createElement('script')
    // script.type = 'text/javascript'
    // script.scr = 'https://www.paypal.com/sdk/js?client-id=AZlglYvUj5rNWnuQHkYSeHw8RCXJxmdBc2EkNrn7urL3HfLRpSzsZgAyiG-_Ja0xEJdzktp7RNSjAGhI'
    // script.async = true
    // script.onload = () => {
    //     setSdkReady(true)
    // }
    // document.body.appendChild(script)

  return (
    <PayPalScriptProvider options={{ "client-id": "AZlglYvUj5rNWnuQHkYSeHw8RCXJxmdBc2EkNrn7urL3HfLRpSzsZgAyiG-_Ja0xEJdzktp7RNSjAGhI" }}>
      <PayPalButtons
        style={{ layout: "vertical" }}
        createOrder={(data, actions) => {
          return actions.order.create({
            purchase_units: [{
              amount: {
                value: amount, // Pass the amount here
                currency_code: currency // Pass the currency here
              }
            }]
          });
        }}
        onApprove={async (data, actions) => {
          const order = await actions.order.capture();
          console.log('Order details:', order);
          onSuccess()
          // Handle the successful transaction here
        }}
        onError={(err) => {
          console.error("PayPal Checkout onError", err);
          // Handle errors here
        }}
        fundingSource = {fundingSource}
      />
    </PayPalScriptProvider>
  );
};

export default PayPalButtonComponent;
